import { ClienteInternacional } from "../ClienteInternacional/ClienteInternacional";
import { Emisor } from "../Emisor/Emisor";
import { GuiaDespacho } from "../GuiaDespacho";
import { Receptor } from "../Receptor/Receptor";
import { ComisionRecargo } from "./ComisionRecargo";
import { DescuentoRecargo } from "./DescuentoRecargo";
import { DetalleDte } from "./DetalleDte";
import { DteEmitido } from "./DteEmitido";
import { Bulto } from "./Exportacion/Bulto";
import { ExportacionTransporteDte } from "./exportacionDte";
import { IDte } from "./IDte";
import { OtraMoneda } from "./OtraMoneda";
import { ReferenciaDteEmitido } from "./ReferenciaDteEmitido";
import { TotalDteEmitido } from "./TotalDteEmitido";

export class FacturaExportacion implements IDte {
	comisionesCargosDte?: ComisionRecargo[];
	comisionCargo?: number;
	dteId?: string;
	receptorId?: string;
	importacionMasivaId: string;
	rutReceptor?: string;
	emisorId?: string;
	tipoDteId?: string;
	codigoTipoDte?: number;
	sucursalId?: string;
	folio: number;
	fecha: Date;
	fechaVencimiento: Date;
	estadoSii: number;
	trackId?: number;
	xmlString?: string;
	formaPago?: string;
	formaPagoEnum?: number;
	archivoExcelId?: string;
	neto?: number;
	iva?: number;
	exento?: number;
	total?: number;
	impuestos?: number;
	fechaProcesamiento?: Date;
	consumoFolioId?: string;
	detalleDte?: Array<DetalleDte>;
	emisorAsociado?: Emisor;
	nombreTipoDte?: string;
	razonSocial?: string;
	receptorAsociado?: Receptor;
	receptorEnt: Receptor;
	clienteInternacionalAsociado: ClienteInternacional;
	anulado?: boolean;
	rutReceptorDv?: string;
	folioReutilizado: boolean;
	estadoAcuse: number;
	descripcionEstadoAcuse: string;
	reutilizarFoliohabilitado: boolean;
	//campos de referencias dte
	fechaDteReferenciado?: Date;
	razonReferencia?: string;
	rutEmisor?: number;
	codigoTipoDteReferencia?: string;
	folioReferencia?: string;
	fechaReferencia?: Date;
	codigoRazonReferencia?: number;
	listaReferenciasDteEmitido: ReferenciaDteEmitido[];
	//tipo de moneda
	tipoMoneda?: string;
	descuentoGlobal?: number;
	formato?: number;
	diasVencimiento?: number;
	otraMonedaEnt?: OtraMoneda;
	DescuentoRecargoEnts?: DescuentoRecargo[];
	notaCreditoHabilitada?: boolean;
	notaDebitoHabilitada?: boolean;
	indicadorServicioExportacion?: number;
	indicadorMontosNetos?: boolean;
	guiaDespacho: GuiaDespacho;
	//campos exportacion;
	transporte: ExportacionTransporteDte;
	modalidadVentaId: number;
	modalidadVentaGlosa: string;
	clausulaVentaId: number;
	clausulaVentaGlosa: string;
	montoClausulaVenta: any;
	puertoEmbarqueId: number;
	territorioEmbarque: string;
	puertoDesembarqueId: number;
	territorioDesembarque: string;
	viaTransporte: string;
	pesoBruto: number;
	pesoNeto: number;
	pesoTara: number;
	uMedidaPeso: number;
	umedidaPesoNeto: number;
	umedidaPesoBruto: number;
	umedidaTara: number;
	seguro: number;
	flete: number;
	derechos: number;
	otro: number;
	numeroItems: number;
	cantidadBultos: number;
	Bultos: Bulto[];
	codigoPaisReceptor: number; //basado en los datos del receptor
	codigoPaisDestino: number; //distinto de receptor? para el lugar donde viaja
	codigoPaisEmisor: number;
	codigoModalidadVenta: number;
	codigoClausulaVenta: number;
	codigoPuertoEmbarque: number;
	codigoPuertoDesembarque: number;
	codigoViaTransporte: number;
	clienteInternacionalId: number;
	nombrePaisDestino: string;
	nombrePuertoDestino: string;
	nombrePuertoEmbarque: string;
	tipoCambio: string;
	montoClp: string;
	totalValorBienes: number;
	tieneIvaTerceros: boolean;
	ivaTerceros: number;
	ivaPropio: number;
	tipoMonedaAduana: string;
	codigoMonedaAduana: number;
	documentosLiquidados: string[];
	guiasFacturadas: string[];
	nombreTransporte: string;
	FormaPagoExportacion: string;
	FormaPagoExportacionEnum?: number;
	observaciones?: string;
	showActions?: boolean;
	public setExportData(transportExport: ExportacionTransporteDte) {
		if (!transportExport) {
			this.cantidadBultos = 0;
			this.Bultos = [];
			return;
		}

		this.puertoEmbarqueId = transportExport.puertoEmbarque;
		this.territorioEmbarque = transportExport.territorioEmbarque;
		this.puertoDesembarqueId = transportExport.puertoDesembarque;
		this.territorioDesembarque = transportExport.territorioDesembarque;
		this.viaTransporte = transportExport.viaTransporte;
		this.pesoBruto = transportExport.pesoBruto;
		this.pesoNeto = transportExport.pesoNeto;
		this.pesoTara = transportExport.tara;
		this.uMedidaPeso = transportExport.medidaPesoNeto;
		this.umedidaPesoNeto = transportExport.medidaPesoNeto;
		this.umedidaPesoBruto = transportExport.medidaPesoBruto;
		this.umedidaTara = transportExport.medidaTara;
		this.seguro = transportExport.seguro;
		this.flete = transportExport.flete;
		if (transportExport.listaBultos && Array.isArray(transportExport.listaBultos) && transportExport.listaBultos.length > 0) {
			this.cantidadBultos = transportExport.listaBultos.reduce((sum, current) => sum + (current && current.cantidadBultos ? current.cantidadBultos : 0), 0);
			this.Bultos = transportExport.listaBultos;
		} else {
			this.cantidadBultos = 0;
			this.Bultos = [];
		}
		this.codigoPaisReceptor = transportExport.codigoPaisReceptor;
		this.codigoPaisDestino = transportExport.codigoPaisDestino;
		this.codigoPuertoEmbarque = transportExport.codigoPuertoEmbarque;
		this.codigoPuertoDesembarque = transportExport.codigoPuertoDesembarque;
		this.codigoViaTransporte = transportExport.codigoViaTransporte;
		this.nombreTransporte = transportExport.nombreTransporte;
	}

	public setTotalesData(totals: TotalDteEmitido) {
		this.modalidadVentaId = totals.modalidadVentaId;
		this.clausulaVentaId = totals.clausulaVentaId;
		this.modalidadVentaGlosa = totals.modalidadVentaNombre;
		this.clausulaVentaGlosa = totals.clausulaVentaGlosa;
		this.codigoModalidadVenta = totals.codigoModalidadVenta;
		this.codigoClausulaVenta = totals.codigoClausulaVenta;
		this.total = totals.montoClausulaVenta;
		this.indicadorServicioExportacion = totals.indicadorServicio;
	}

	public toDteEmitido() {
		let dte: DteEmitido = new DteEmitido();
		dte.dteId = this.dteId;
		dte.receptorId = this.receptorId;
		dte.rutReceptor = this.rutReceptor;
		dte.emisorId = this.emisorId;
		dte.tipoDteId = this.tipoDteId;
		dte.codigoTipoDte = this.codigoTipoDte;
		dte.sucursalId = this.sucursalId;
		dte.folio = this.folio;
		dte.fecha = this.fecha;
		dte.estadoSii = this.estadoSii;
		dte.trackId = this.trackId;
		dte.xmlString = this.xmlString;
		dte.formaPago = this.formaPago;
		dte.formaPagoEnum = this.formaPagoEnum;

		dte.FormaPagoExportacion = this.FormaPagoExportacion;
		dte.FormaPagoExportacionEnum = this.FormaPagoExportacionEnum;

		dte.archivoExcelId = this.archivoExcelId;
		dte.neto = this.neto;
		dte.iva = this.iva;
		dte.exento = this.exento;
		dte.total = this.total;
		dte.impuestos = this.impuestos;
		dte.fechaProcesamiento = this.fechaProcesamiento;
		dte.consumoFolioId = this.consumoFolioId;
		dte.detalleDte = this.detalleDte;
		dte.emisorAsociado = this.emisorAsociado;
		dte.nombreTipoDte = this.nombreTipoDte;
		dte.razonSocial = this.razonSocial;
		dte.receptorAsociado = this.receptorAsociado;
		dte.anulado = this.anulado;
		dte.rutReceptorDv = this.rutReceptorDv;

		dte.fechaDteReferenciado = this.fechaDteReferenciado;
		dte.razonReferencia = this.razonReferencia;
		dte.rutEmisor = this.rutEmisor;
		dte.codigoTipoDteReferencia = this.codigoTipoDteReferencia;
		dte.folioReferencia = this.folioReferencia;
		dte.fechaReferencia = this.fechaReferencia;
		dte.codigoRazonReferencia = this.codigoRazonReferencia;

		dte.tipoMoneda = this.tipoMoneda;
		dte.descuentoGlobal = this.descuentoGlobal;
		dte.formato = this.formato;
		dte.diasVencimiento = this.diasVencimiento;
		dte.otraMonedaEnt = this.otraMonedaEnt;
		dte.DescuentoRecargoEnts = this.DescuentoRecargoEnts;
		dte.notaCreditoHabilitada = this.notaCreditoHabilitada;
		dte.notaDebitoHabilitada = this.notaDebitoHabilitada;
		dte.indicadorServicio = this.indicadorServicioExportacion;
		dte.indicadorMontosNetos = this.indicadorMontosNetos;
		dte.tipoMonedaAduana = this.tipoMonedaAduana;
		dte.codigoMonedaAduana = this.codigoMonedaAduana;
		dte.listaReferenciasDteEmitido = this.listaReferenciasDteEmitido;
		dte.observaciones = this.observaciones;
		dte.indicadorServicio = this.indicadorServicioExportacion;
		return dte;
	}

	rewriteDetailsByForeignCurrency() {
		this.detalleDte.forEach((detalle) => {
			detalle.precioUnitario = detalle.originalValuePrice;
			detalle.subtotal = detalle.originalSubtotal;
			detalle.recargo = detalle.originalRecharge;
			detalle.descuento = detalle.originalDiscount;
			detalle.total = detalle.originalTotal;
		});
	}

	rewriteTotals() {
		this.totalValorBienes = this.exento;
	}
}
